/* Bandeau d'annonce — rotation automatique des messages (fondu), pause au survol */
(function () {
  document.querySelectorAll('.announcement-battle').forEach((bar) => {
    const slides = bar.querySelectorAll('.announcement-battle__slide');
    if (slides.length < 2) return;

    const speed = (parseInt(bar.dataset.rotateSpeed, 10) || 5) * 1000;
    let current = 0;
    let timer;

    const show = (index) => {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = index % slides.length;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
    };

    const start = () => {
      timer = setInterval(() => show(current + 1), speed);
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', start);
    start();
  });
})();
